<template>
  <modal @before-open="beforeOpen" @opened="opened" :resizable="true" name="extraPage" :draggable="'.header'" :reset="true" :classes="['todobox','generalbox']" :adaptive="true"
          :height="width" :width="height" :max-width="maxWidth" :max-height="maxHeight" :min-width="1092"
         :min-height="614" :click-to-close="false" :pivotX="pivotX" :pivotY="pivotY">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>{{modalTitle}}</h2>
    </div>
    <div class="content">
      <div class="extraPageContainer">
        <iframe class="extraPage" :src="pageURL" frameborder="0"></iframe>
      </div>

    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //通信总线
  import Bus from 'common/js/bus.js';

  export default {
    name: "notice",
    data() {
      return {
        pageURL:null,
        modalTitle:null,
        width:'80%',
        maxWidth:1540,
        height:'80%',
        maxHeight:885,
        //浮窗层叠
        pivotX:0.5,
        pivotY:0.5,
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("extraPage");
        Bus.$emit("todoHandleFinish",{});
      },
      beforeOpen(data){
        this.pageURL=data.params.url;
        this.modalTitle=data.params.title;
        if(data.params.setModalSize){
          this.width=data.params.width;
          this.height=data.params.height;
          this.maxWidth=999999;
          this.maxHeight=999999;
        }
        if(data.params.stackLayout){
          this.pivotX=this.modalOffsetDistance.x
          this.pivotY=this.modalOffsetDistance.y
        }
      },
      opened(){
        this.updateModalZIndex(this.$el)
        Bus.$on('setExtraPageZIndexTop',(ev)=>{
          this.updateModalZIndex(this.$el)
        })
      },
    },
    computed: {
      ...mapState(['modalOffsetDistance'])
    },
    mounted() {},
    filters:{},
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    .extraPageContainer
      width 100%
      height 100%
      .extraPage
        width 100%
        height 100%
</style>


// WEBPACK FOOTER //
// src/components/globalComp/extraPageModal.vue